const health = {
  healthy: "Здоров",
  atRisk: "Под угрозой",
  critical: "Критический",
} as const;
export default health;
